import { useCallback } from "react";
import { FcIdea } from "react-icons/fc";
import InfiniteScroll from "react-infinite-scroller";
import { ColorRing } from "react-loader-spinner";

import { Link } from "shared/components";
import { BFC } from "shared/types";

import { routes } from "~/constants";

import { ProductCard } from "../../components";
import { usePopularProducts } from "../../hooks";

export const PopularProductsPage: BFC = () => {
  const { products, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage } = usePopularProducts();

  const loadMore = useCallback(() => {
    fetchNextPage();
  }, [fetchNextPage]);

  return (
    <div className="flex flex-col gap-4 pb-4">
      <div className="bg-white p-3">
        <div className="flex flex-wrap items-center">
          <div className="flex gap-1 mr-auto">
            <FcIdea size={20} />
            <h2 className="font-bold text-lg">人気・おすすめ</h2>
          </div>
        </div>
        <InfiniteScroll loadMore={loadMore} hasMore={hasNextPage}>
          <div className="mt-3 grid grid-cols-2 gap-x-3 gap-y-6 md:grid-cols-4">
            {products.map((product) => (
              <Link key={product.id} href={routes.PRODUCTS_SHOW(product.id)} noDecoration>
                <ProductCard
                  product={product}
                />
              </Link>
            ))}
          </div>
        </InfiniteScroll>
        {(isLoading || isFetchingNextPage) && (
          <div className="flex justify-center items-center">
            <ColorRing />
          </div>
        )}
      </div>
    </div>
  );
};
